import {
  CTD_DETAILS_REQUEST,
  CTD_DETAILS_SUCCESS,
  CTD_DETAILS_FAIL,
  CTD_DETAILS_RESET,
  
  CTD_CREATE_REQUEST,
  CTD_CREATE_SUCCESS,
  CTD_CREATE_FAIL,
  CTD_CREATE_RESET,

  CTD_UPDATE_REQUEST,
  CTD_UPDATE_SUCCESS,
  CTD_UPDATE_FAIL,
  CTD_UPDATE_RESET, 
  
  CTD_DELETE_REQUEST,
  CTD_DELETE_SUCCESS,
  CTD_DELETE_FAIL,
  CTD_DELETE_RESET, 
  
  CTD_LIST_REQUEST,
  CTD_LIST_SUCCESS,
  CTD_LIST_FAIL,
  CTD_LIST_RESET, 
} from '../constants/customerTaxDutyConstants';
// Initial States
const initialState = {
  loading: false,
  success: false,
  error: null,
};

const initialListState = {
  loading: false,
  taxDuties: [],
  error: null,
};

const initialDetailsState = {
  loading: false,
  taxDuty: null,
  error: null,
};

// Customer Tax Duty List Reducer
export const customerTaxDutyListReducer = (state = initialListState, action) => {
  switch (action.type) {
    case CTD_LIST_REQUEST:
      return { loading: true, taxDuties: [] };
    case CTD_LIST_SUCCESS:
      return { loading: false, taxDuties: action.payload };
    case CTD_LIST_FAIL:
      return { loading: false, error: action.payload };
    case CTD_LIST_RESET:
      return initialListState;
    default:
      return state;
  }
};

// Customer Tax Duty Details Reducer
export const customerTaxDutyDetailsReducer = (state = initialDetailsState, action) => {
  switch (action.type) {
    case CTD_DETAILS_REQUEST:
      return { loading: true, ...state };
    case CTD_DETAILS_SUCCESS:
      return { loading: false, taxDuty: action.payload };
    case CTD_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case CTD_DETAILS_RESET:
      return initialDetailsState;
    default:
      return state;
  }
};

// Customer Tax Duty Create Reducer
export const customerTaxDutyCreateReducer = (state = initialState, action) => {
  switch (action.type) {
    case CTD_CREATE_REQUEST:
      return { loading: true };
    case CTD_CREATE_SUCCESS:
      return { loading: false, success: true };
    case CTD_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case CTD_CREATE_RESET:
      return initialState;
    default:
      return state;
  }
};

// Customer Tax Duty Update Reducer
export const customerTaxDutyUpdateReducer = (state = initialState, action) => {
  switch (action.type) {
    case CTD_UPDATE_REQUEST:
      return { loading: true };
    case CTD_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case CTD_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case CTD_UPDATE_RESET:
      return initialState;
    default:
      return state;
  }
};

// Customer Tax Duty Delete Reducer
export const customerTaxDutyDeleteReducer = (state = initialState, action) => {
  switch (action.type) {
    case CTD_DELETE_REQUEST:
      return { loading: true };
    case CTD_DELETE_SUCCESS:
      return { loading: false, success: true };
    case CTD_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case CTD_DELETE_RESET:
      return initialState;
    default:
      return state;
  }
};
// // Reducer for listing all customer tax duties
// export const customerTaxDutyListReducer = (state = { taxDuties: [] }, action) => {
//   switch (action.type) {
//     case CTD_LIST_REQUEST:
//       return { loading: true };
//     case CTD_LIST_SUCCESS:
//       return { loading: false, taxDuties: action.payload };
//     case CTD_LIST_FAIL:
//       return { loading: false, error: action.payload };
//     default:
//       return state;
//   }
// };

// // Reducer for customer tax duty details
// export const customerTaxDutyDetailsReducer = (state = { taxDuty: {} }, action) => {
//   switch (action.type) {
//     case CTD_DETAILS_REQUEST:
//       return { loading: true, ...state };
//     case CTD_DETAILS_SUCCESS:
//       return { loading: false, taxDuty: action.payload };
//     case CTD_DETAILS_FAIL:
//       return { loading: false, error: action.payload };
//     default:
//       return state;
//   }
// };

// // Reducer for creating tax duty
// export const customerTaxDutyCreateReducer = (state = {}, action) => {
//   switch (action.type) {
//     case CTD_CREATE_REQUEST:
//       return { loading: true };
//     case CTD_CREATE_SUCCESS:
//       return { loading: false, success: true, taxDuty: action.payload };
//     case CTD_CREATE_FAIL:
//       return { loading: false, error: action.payload };
//     default:
//       return state;
//   }
// };

// // Reducer for updating tax duty
// export const customerTaxDutyUpdateReducer = (state = {}, action) => {
//   switch (action.type) {
//     case CTD_UPDATE_REQUEST:
//       return { loading: true };
//     case CTD_UPDATE_SUCCESS:
//       return { loading: false, success: true };
//     case CTD_UPDATE_FAIL:
//       return { loading: false, error: action.payload };
//     default:
//       return state;
//   }
// };

// // Reducer for deleting tax duty
// export const customerTaxDutyDeleteReducer = (state = {}, action) => {
//   switch (action.type) {
//     case CTD_DELETE_REQUEST:
//       return { loading: true };
//     case CTD_DELETE_SUCCESS:
//       return { loading: false, success: true };
//     case CTD_DELETE_FAIL:
//       return { loading: false, error: action.payload };
//     default:
//       return state;
//   }
// };
